import { GetCulpritPreviousCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritPreviousCorrectiveImages/getCulpritPreviousCorrectiveImages.type';
import { getCulpritPreviousCorrectiveImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritPreviousCorrectiveImages/getCulpritPreviousCorrectiveImagesFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritPreviousCorrectiveImagesOptions = (
  params: GetCulpritPreviousCorrectiveImagesType,
) =>
  queryOptions({
    queryKey: ['getCulpritPreviousCorrectiveImagesOptions', params],
    queryFn: () => getCulpritPreviousCorrectiveImagesFunction(params),
  });
